import React from 'react';
import { ButtonSize, Button, HoverStyles } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import { classes } from './next-button.st.css';
import { ForcedState, useForcedState } from '../../../../../contexts/forced-state-context';
const NextButton = _ref => {
  let {
    nextText,
    className,
    onClick
  } = _ref;
  const forcedState = useForcedState();
  const hover = forcedState.includes(ForcedState.NEXT_BUTTON_HOVER);
  return /*#__PURE__*/React.createElement(Button, {
    className: classNames(classes.nextButton, {
      [classes.nextButtonHover]: hover
    }, className),
    hoverStyle: HoverStyles.underline,
    upgrade: true,
    wrapContent: true,
    size: ButtonSize.large,
    onClick: onClick,
    "data-hook": "next-button"
  }, nextText);
};
export default NextButton;
//# sourceMappingURL=next-button.js.map